<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'

    import WalletsComponent from './component.wallets.svelte'

    if(!isPermission($adminStore, 'UsersView.Wallet.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Saldos" subtitle="Carteras y saldos de usuarios" />
    <WalletsComponent />
</View>
